export const CMSLIST_DETAILS = 'CMSLIST_DETAILS';
export const CMSLIST_DETAILS_BY_ID = 'CMSLIST_DETAILS_BY_ID';
